// Routes that show signed-out visitors a landing view instead of raising the
// sign-in modal on arrival. Keyed by path; the value is the landing's key in
// src/data/guestLandings.js. Kept here, free of Vue and of the data module,
// because main.js reads it before the app exists to pick the fast public
// mount for these routes.
export const GUEST_LANDING_ROUTES = Object.freeze({
    '/g25': 'g25',
    '/calculators': 'calculators',
    '/admixplus': 'admixplus',
    '/pca': 'pca',
    '/familytree': 'familytree',
    '/tree': 'familytree',
    '/health': 'health',
})

// Older URLs for a tool that has a landing elsewhere: a signed-out visitor
// is sent to that one (query kept, so ?calculator= links still resolve)
// rather than given a second copy of the same view under another address.
export const GUEST_LANDING_ALIASES = Object.freeze({
    '/admix': '/calculators',
    '/admixcalc': '/calculators',
    '/admixpath': '/calculators',
    '/admixold': '/calculators',
})

export function guestLandingFor(pathname) {
    if (!pathname) return null
    let path = (pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname).toLowerCase()
    path = GUEST_LANDING_ALIASES[path] || path
    return GUEST_LANDING_ROUTES[path] || null
}

// document.title with the environment prefix the router guard adds.
export function titleForEnv(store, title) {
    const env = store && store.getters.get('env')
    return (env === 'development' ? 'DEV ' : env === 'staging' ? 'Staging ' : '') + title
}

// "Is someone signed in on this browser?", answerable before Amplify is
// configured: the Cognito LastAuthUser key the router guard and Nav's
// cachedAuthUser() already trust, plus the per-tab copy the guard writes once
// a session is confirmed. Scanned rather than hardcoded so it holds for every
// environment's client id. Only a hint: Cognito leaves the key behind after
// expiry, and Nav's currentAuthenticatedUser() catch corrects that case.
export function hasSignInHint() {
    try {
        if (sessionStorage.getItem('user')) return true
        for (let i = 0; i < localStorage.length; i++) {
            const k = localStorage.key(i)
            if (k && k.startsWith('CognitoIdentityServiceProvider.') && k.endsWith('.LastAuthUser') && localStorage.getItem(k)) {
                return true
            }
        }
    } catch (e) { /* storage blocked: treat as signed out */ }
    return false
}
